import React from 'react';
 import SignupForm from "../Components/SignupForm";


export default function Signup() {
  return (
    <div>
       <SignupForm />
    </div>
  )
}
